import React from "react";
import { get } from "lodash";
import { Col, Collapse } from "react-bootstrap";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import {
  CurrencyField,
  Check,
  CheckGroup
} from "MODULES/shared/components/Forms";
import { hasRole } from "MODULES/users/helpers";
import { ACCOUNTING } from "MODULES/users/constants";
import { dollars } from "LIB/formatters/currency";
import Warning from "MODULES/shared/components/Warning/Warning";
import { HAZMAT } from "MODULES/parts/constants";
import { properCase } from "LIB/formatters/text";
import { useSettings } from "APP_ROOT/hooks/useCurrentUser";
import { DEFAULT_HAZMAT_FEE } from "APP_ROOT/constants";
import FormRow from "../../../shared/components/Forms/FormRow";

export default class PartFee extends React.Component {
  static propTypes = {
    currentSeller: PropTypes.shape({}),
    item: PropTypes.shape({}),
    part: PropTypes.shape({}),
    hazmat: PropTypes.bool,
    specialContainer: PropTypes.bool,
    change: PropTypes.func,
    getField: PropTypes.func,
    left: PropTypes.element
  };

  handleHazmatFee(item) {
    if (!this.props.hazmat) {
      const hazmatFee = get(useSettings(), DEFAULT_HAZMAT_FEE, 75);
      this.props.change(`${item}.hazmat_fee`, hazmatFee);
    } else {
      this.props.change(`${item}.hazmat_fee`, null);
    }
  }

  handleContainerFee(item) {
    if (this.props.specialContainer) {
      this.props.change(`${item}.container_fee`, null);
    }
  }

  render() {
    const {
      currentUser,
      item,
      part,
      hazmat,
      specialContainer,
      getField,
      left
    } = this.props;
    const hazmatSelected = getField(`${item}.${HAZMAT}`);

    return (
      <tr>
        <td>
          {specialContainer && (
            <FormRow>
              <Col md={12}>
                <Warning warningType="warning">
                  PN-{part.part_number} is flagged as requiring a special
                  container fee of {dollars(part.special_container_fee)} and has
                  been auto-populated below.
                </Warning>
              </Col>
            </FormRow>
          )}
          <FormRow>
            {left}
            <Col md={3}>
              <CheckGroup title="Line Hazmat" justified>
                <Field
                  name={`${item}.${HAZMAT}`}
                  disabled={!hasRole(currentUser || {}, ACCOUNTING)}
                  component={Check}
                  label={properCase(HAZMAT)}
                  icon="fa-warning"
                  onChange={() => this.handleHazmatFee(item)}
                />
              </CheckGroup>
            </Col>
            <Collapse in={hazmat} unmountOnExit>
              <Col md={3}>
                <div>
                  <CurrencyField
                    name={`${item}.hazmat_fee`}
                    label="Hazmat Fee"
                    required
                  />
                </div>
              </Col>
            </Collapse>
            <Col md={3}>
              <div className="form-group">
                <label htmlFor="special-container" className="control-label">
                  Special Container
                </label>
                <br />
                <div
                  id="special-container"
                  className="btn-group btn-group-justified"
                  data-toggle="buttons"
                >
                  <Field
                    component={Check}
                    name={`${item}.special_container_req`}
                    label="Special Container Req."
                    icon="fa-cube"
                    onChange={() => this.handleContainerFee(item)}
                  />
                </div>
              </div>
            </Col>
            <Col md={3}>
              <Collapse in={specialContainer} unmountOnExit>
                <div>
                  <CurrencyField
                    name={`${item}.container_fee`}
                    label="Special Container Fee"
                    required
                  />
                </div>
              </Collapse>
            </Col>
            <Col md={3}>
              <Collapse in={!hazmatSelected && specialContainer} unmountOnExit>
                <div className="form-group">
                  <label
                    htmlFor="customer-to-return-container"
                    className="control-label"
                  >
                    Customer to Return Container
                  </label>
                  <div
                    id="customer-to-return-container"
                    className="btn-group btn-group-justified"
                    data-toggle="buttons"
                  >
                    <Field
                      component={Check}
                      name={`${item}.customer_to_return_container`}
                      label="Cust. to Rtrn Cont."
                      icon="fa-cube"
                    />
                  </div>
                </div>
              </Collapse>
            </Col>
          </FormRow>
          <FormRow>
            <Col md={6} />
            <Col md={3}>
              <Collapse in={hazmatSelected && specialContainer} unmountOnExit>
                <div>
                  <div className="form-group">
                    <label
                      htmlFor="customer-to-return-container"
                      className="control-label"
                    >
                      Customer to Return Container
                    </label>
                    <div
                      id="customer-to-return-container"
                      className="btn-group btn-group-justified"
                      data-toggle="buttons"
                    >
                      <Field
                        component={Check}
                        name={`${item}.customer_to_return_container`}
                        label="Cust. to Rtrn Cont."
                        icon="fa-cube"
                      />
                    </div>
                  </div>
                </div>
              </Collapse>
            </Col>
          </FormRow>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/ReserveForSale/ConvertDummyForm/PartFee.jsx